export const environment = {
  production: true,
  baseUrl: 'https://uat.api.msm.com.ph/v1'
};
